export const PermissionList = <TPerm extends string>(list: TPerm[]) => list;
